import { useEffect, useState } from "react";
import { connect } from "react-redux";

// eslint-disable-next-line
import Button from "./button";
import { getAddressByCEP, patchClient } from "../api/services";

import {
  formatCEP,
  formatDocumentType,
  formatNumber,
  formatPhone,
  formatVoucher,
  isCelular,
  ufs,
} from "../helpers/helpers";
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// import "./../styles/form.css";
import "react-toastify/dist/ReactToastify.css";
import { purchasingScheme } from "../helpers/validations";
import { Form } from "../helpers/interfaces";
import { Bounce, toast, ToastContainer } from "react-toastify";
import { Dangerous } from "@mui/icons-material";

/**
 * @param props - props recebidas pelo componente
 * @returns Um elemento de formulário estilizado
 *
 * Componente de formulário para compra de produtos com validações.
 */

const FormToBuy = (props: any) => {
  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(purchasingScheme),
  });

  const [loading, setLoading] = useState(false);
  const [uf, setUf] = useState(ufs);
  const [requestBody, setRequestBody] = useState<Form>({
    vouch_inid_voucher: 0,
    vouch_inid_cliente: "",
    vouch_dmtp_documento: "J",
    vouch_binu_documento: props.document ? formatNumber(props.document) : "",
    vouch_vcnm_voucher: props.voucher ? formatVoucher(props.voucher) : "",
    vouch_vcnm_responsavel: "",
    vouch_vcnm_razaosocial: "",
    vouch_vcnm_fantasia: "",
    vouch_binu_telefoneresponsavel: "",
    vouch_vcem_responsavel: "",
    vouch_chcd_cep: "",
    vouch_vcds_endereco: "",
    vouch_vcnu_numero: "",
    vouch_vcds_complemento: "",
    vouch_vcnm_bairro: "",
    vouch_vcnm_cidade: "",
    vouch_chcd_uf: "",
    vouch_chcd_logradouro: "",
    vouch_dmnu_cpfresponsavel: "",
    vouch_dmtp_cpfresponsavel: "",
  });
  const [onlyName, setOnlyname] = useState(true);

  const [clientReadOnly, setClientReadOnly] = useState(false);
  const [countRedirect, setCountRedirect] = useState(10);
  const [linkRedirect, setLinkRedirect] = useState("");
  const [countDocumentResponsavel, setCountDocumentResponsavel] = useState(0);
  const [countCelular, setCountCelular] = useState(0);
  const [countField, setCountField] = useState(0);
  const [countCep, setCountCep] = useState(0);
  const [countNumero, setCountNumero] = useState(0);
  const [progressBar, setProgressBar] = useState(0);
  const [titleProgressBar, setTitleProgressBar] = useState("AGUARDE...");
  const [textProgressBar, setTextProgressBar] = useState(
    "O seu CUPOM está sendo processado. <br> NÃO FECHE OU RECARREGUE ESSA PÁGINA.",
  );
  const [errorProgress, setErrorProgress] = useState(false);
  const [errorTextProgress, setErrorTextProgress] = useState(
    "ERRO NO PROCESSAMENTO!",
  );

  //carrousel
  const [carouselIndex, setCarouselIndex] = useState(0);
  const images = [
    "https://sistemas.connectsa.com.br/cdn/imagens/carrossel_sdsn_1.jpg",
    "https://sistemas.connectsa.com.br/cdn/imagens/carrossel_sdsn_2.jpg",
    "https://sistemas.connectsa.com.br/cdn/imagens/carrossel_sdsn_3.jpg"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCarouselIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setCarouselIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setCarouselIndex((prev) => (prev + 1) % images.length);
  };

  let sessionAccessToken = props.session.access_token
    ? props.session.access_token
    : "-";
  let urlRedirect = props.whitelabel.urlChangePassword
    ? props.whitelabel.urlChangePassword
    : import.meta.env.VITE_URL_SATURNO;

  let sessionUrlApi = props.whitelabel.urlApi ? props.whitelabel.urlApi : "-";
  //UseEffects
  useEffect(() => {
    setLoading(true);
    startForm();
    setUf(ufs);
    setLoading(false);
    setOnlyname(props.typeDocument === "F" ? true : false);
  }, [setLoading]);
  const startForm = () => {
    setCountCelular(15);
    setCountField(50);
    setCountCep(9);
    setCountNumero(5);
    setCountDocumentResponsavel(14);
    setDataInForm();
  };

  //search cep
  const searchCEP = async (e: any, fromSearchClient?: boolean) => {
    if (!fromSearchClient) setLoading(true);
    try {
      const response: any = await getAddressByCEP(formatNumber(e));
      setRequestBody((requestBody) => ({
        ...requestBody,
        vouch_vcds_endereco: "",
        vouch_vcnm_bairro: "",
        vouch_vcnm_cidade: "",
        vouch_chcd_uf: "",
        vouch_vcnu_numero: "",
        vouch_vcds_complemento: "",
      }));
      if (response.cep.length > 0 && response.logradouro) {
        let res = response;
        setValue("vouch_vcds_endereco", res.logradouro, {
          shouldValidate: true,
        });
        setValue("vouch_vcnm_bairro", res.bairro, { shouldValidate: true });
        setValue("vouch_vcnm_cidade", res.localidade, { shouldValidate: true });
        setValue("vouch_chcd_uf", res.uf, { shouldValidate: true });
        setRequestBody((requestBody) => ({
          ...requestBody,
          vouch_chcd_cep: e,
          vouch_vcds_endereco: res.logradouro,
          vouch_vcnm_bairro: res.bairro,
          vouch_vcnm_cidade: res.localidade,
          vouch_chcd_uf: res.uf,
          vouch_vcnu_numero: "",
          vouch_vcds_complemento: "",
        }));
      } else {
        toast.dismiss();
        toast.warn("CEP inválido. Verifique e tente novamente.", {
          toastId: Date.now().toString(),
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
      //   }
      // );
    } catch (error) {
      console.error(error);
    } finally {
      if (!fromSearchClient) setLoading(false);
    }
    if (!fromSearchClient) {
      setLoading(false);
    }
  };
  const drainFields = (a?: any) => {
    setClientReadOnly(false);
    if (a) {
      setRequestBody({
        ...requestBody,
        vouch_binu_documento: "",
        vouch_vcnm_razaosocial: "",
        vouch_vcnm_fantasia: "",
        vouch_binu_telefoneresponsavel: "",
        vouch_vcem_responsavel: "",
        vouch_chcd_cep: "",
        vouch_vcds_endereco: "",
        vouch_vcnu_numero: "",
        vouch_vcds_complemento: "",
        vouch_vcnm_bairro: "",
        vouch_vcnm_cidade: "",
        vouch_chcd_uf: "",
      });
    } else {
      setRequestBody({
        ...requestBody,
        vouch_vcnm_razaosocial: "",
        vouch_vcnm_fantasia: "",
        vouch_binu_telefoneresponsavel: "",
        vouch_vcem_responsavel: "",
        vouch_chcd_cep: "",
        vouch_vcds_endereco: "",
        vouch_vcnu_numero: "",
        vouch_vcds_complemento: "",
        vouch_vcnm_bairro: "",
        vouch_vcnm_cidade: "",
        vouch_chcd_uf: "",
      });
    }
  };

  const onSubmitForm = () => {
    setProgressBar(70);
    // let email = "analista29.ti@connectsa.com.br";
    // let senha = "VnZxo@h1";
    //   window.open(
    //     `https://plataforma-stage.ctplus.com.br/primeiro-acesso?email=${email}&token=${senha}`,
    //     "_self",
    // );

    patchClient(sessionUrlApi, sessionAccessToken, requestBody).then(
      (response: any) => {
        setProgressBar(101);
        if (response?.status?.codigo === 0) {
          const tokenUrlEncoded = encodeURIComponent(response.detalhe.token);
          setInterval(() => {
            setCountRedirect((prev) => prev - 1);
            if (countRedirect <= 0) {
              clearInterval(this);
            }
          }, 1000);

          setLinkRedirect(
            `${urlRedirect}?email=${requestBody.vouch_vcem_responsavel}&token=${tokenUrlEncoded}&idm=629&ids=659`,
          );
          setTimeout(() => {
            window.open(
              `${urlRedirect}?email=${requestBody.vouch_vcem_responsavel}&token=${tokenUrlEncoded}&idm=629&ids=659`,
              "_self",
            );
          }, countRedirect * 1000);
        } else {
          toast.dismiss();
          toast.error(response?.status?.mensagem || "Erro de processamento!", {
            toastId: Date.now().toString(),
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          setErrorProgress(true);
          setErrorTextProgress(
            response?.status?.mensagem || "Erro de processamento!",
          );
        }
      },
    );
  };

  const setDataInForm = () => {
    setRequestBody({
      ...props.dataVoucher,
      vouch_binu_documento: formatNumber(
        props.dataVoucher.vouch_dmnu_documento,
      ),
      vouch_binu_telefoneresponsavel: isCelular(
        props.dataVoucher.vouch_binu_telefoneresponsavel,
      )
        ? formatNumber(props.dataVoucher.vouch_binu_telefoneresponsavel)
        : "",
    });
    setValue(
      "vouch_binu_documento",
      formatNumber(props.dataVoucher.vouch_dmnu_documento),
      { shouldValidate: true },
    );
    setValue(
      "vouch_vcnm_razaosocial",
      props.dataVoucher.vouch_vcnm_razaosocial,
      { shouldValidate: true },
    );
    if (props.dataVoucher.vouch_dmtp_documento === "J") {
      setValue("vouch_vcnm_fantasia", props.dataVoucher.vouch_vcnm_fantasia, {
        shouldValidate: true,
      });
    } else {
      setValue(
        "vouch_vcnm_fantasia",
        props.dataVoucher.vouch_vcnm_razaosocial,
        { shouldValidate: true },
      );
    }
    setValue(
      "vouch_vcnm_responsavel",
      props.dataVoucher.vouch_vcnm_responsavel,
      { shouldValidate: true },
    );
    setValue(
      "vouch_dmnu_cpfresponsavel",
      formatNumber(props.dataVoucher.vouch_dmnu_cpfresponsavel),
      { shouldValidate: true },
    );
    setValue(
      "vouch_vcem_responsavel",
      props.dataVoucher.vouch_vcem_responsavel,
      { shouldValidate: true },
    );
    setValue(
      "vouch_bite_celular",
      isCelular(props.dataVoucher.vouch_binu_telefoneresponsavel)
        ? formatNumber(props.dataVoucher.vouch_binu_telefoneresponsavel)
        : "",
      { shouldValidate: true },
    );
    setValue("vouch_chcd_cep", props.dataVoucher.vouch_chcd_cep, {
      shouldValidate: true,
    });
    setValue("vouch_vcds_endereco", props.dataVoucher.vouch_vcds_endereco, {
      shouldValidate: true,
    });
    setValue("vouch_vcnu_numero", props.dataVoucher.vouch_vcnu_numero, {
      shouldValidate: true,
    });
    setValue("vouch_vcnm_bairro", props.dataVoucher.vouch_vcnm_bairro, {
      shouldValidate: true,
    });
    setValue("vouch_vcnm_cidade", props.dataVoucher.vouch_vcnm_cidade, {
      shouldValidate: true,
    });
    setValue("vouch_chcd_uf", props.dataVoucher.vouch_chcd_uf, {
      shouldValidate: true,
    });
    setLoading(false);
    const SESSION_KEY_EMAIL = "firstAccessEmail";
    const SESSION_KEY_PASSWORD = "firstAccessPassword";

    localStorage.setItem(
      SESSION_KEY_EMAIL,
      props.dataVoucher.vouch_vcem_principal,
    );
    localStorage.setItem(SESSION_KEY_PASSWORD, "Teste@123");
  };

  //Handles
  function handlePFPJ(e: any) {
    setClientReadOnly(false);
    setOnlyname(e.target.value === "F" ? true : false);
    if (e.target.value === "F") {
      setValue("vouch_vcnm_fantasia", "default");
    }
    let a = true;
    drainFields(a);
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_dmtp_documento: e.target.value,
    }));
  }

  function handleDocumento(e: any) {
    const rawValue = e.target.value.replace(/\D/g, "");
    const formatted = formatDocumentType(
      rawValue,
      requestBody?.vouch_dmtp_documento || e.target.value.length === 11
        ? "F"
        : "J",
    );

    // handleDocumentoBeneficiario(e);
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_binu_documento: rawValue,
    }));
    setValue("vouch_binu_documento", formatted, { shouldValidate: true });
  }

  function handleDocumentoResponsavel(e: any) {
    let doc = "" + formatNumber(e.target.value);
    let typeDoc = doc.length < 15 ? "F" : "J";
    setValue("vouch_dmnu_cpfresponsavel", doc, { shouldValidate: true });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_dmtp_documentoresponsavel: typeDoc,
      vouch_dmnu_cpfresponsavel: doc,
    }));
  }

  function handleNomeResponsavel(e: any) {
    setValue("vouch_vcnm_responsavel", e.target.value.toUpperCase(), {
      shouldValidate: true,
    });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_vcnm_responsavel: e.target.value.toUpperCase(),
    }));
  }

  function handleNomeRazaoSocial(e: any) {
    if (requestBody.vouch_dmtp_documento === "J") {
      setValue("vouch_vcnm_razaosocial", e.target.value.toUpperCase(), {
        shouldValidate: true,
      });
      setRequestBody((requestBody) => ({
        ...requestBody,
        vouch_vcnm_razaosocial: e.target.value.toUpperCase(),
      }));
    } else {
      setValue("vouch_vcnm_razaosocial", "default");
      setRequestBody((requestBody) => ({
        ...requestBody,
        vouch_vcnm_razaosocial: "default",
      }));
    }
  }

  function handleNomeFantasia(e: any) {
    if (requestBody.vouch_dmtp_documento === "J") {
      setValue("vouch_vcnm_fantasia", e.target.value.toUpperCase(), {
        shouldValidate: true,
      });
      setRequestBody((requestBody) => ({
        ...requestBody,
        vouch_vcnm_fantasia: e.target.value.toUpperCase(),
      }));
    } else {
      setValue("vouch_vcnm_fantasia", "default");
      setRequestBody((requestBody) => ({
        ...requestBody,
        vouch_vcnm_fantasia: "default",
      }));
    }
  }

  function handleTelefone(e: any) {
    let cel = "" + e.target.value;
    setValue("vouch_bite_celular", formatNumber(cel), { shouldValidate: true });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_binu_telefoneresponsavel: formatNumber(cel),
    }));
  }

  function handleEmail(e: any) {
    setValue("vouch_vcem_responsavel", e.target.value, {
      shouldValidate: true,
    });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_vcem_responsavel: e.target.value,
    }));
  }
  function handleCEP(e: any) {
    setValue("vouch_chcd_cep", e.target.value, { shouldValidate: true });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_chcd_cep: e.target.value,
    }));
  }

  function handleEndereco(e: any) {
    setValue("vouch_vcds_endereco", e.target.value, { shouldValidate: true });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_vcds_endereco: e.target.value,
    }));
  }

  function handleNumero(e: any) {
    let numberInsert: any = formatNumber(e.target.value);
    setValue("vouch_vcnu_numero", e.target.value, { shouldValidate: true });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_vcnu_numero: numberInsert,
    }));
  }

  function handleComplemento(e: any) {
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_vcds_complemento: e.target.value,
    }));
  }

  function handleBairro(e: any) {
    setValue("vouch_vcnm_bairro", e.target.value, { shouldValidate: true });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_vcnm_bairro: e.target.value,
    }));
  }

  function handleCidade(e: any) {
    setValue("vouch_vcnm_cidade", e.target.value, { shouldValidate: true });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_vcnm_cidade: e.target.value,
    }));
  }

  function handleEstado(e: any) {
    setValue("vouch_chcd_uf", e.target.value, { shouldValidate: true });
    setRequestBody((requestBody) => ({
      ...requestBody,
      vouch_chcd_uf: e.target.value,
    }));
  }
  //function to block paste
  // const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
  //   event.preventDefault();
  // };

  return (
    <div className="fixed inset-0 w-full h-screen bg-black/70 text-center z-50">
      <ToastContainer style={{ zIndex: 100 }} />
      {progressBar === 0 ? (
        <>
          <div
            className="relative w-[90%] min-w-[300px] bg-[var(--color-background)] border border-white/80 my-5 mx-auto p-5 overflow-visible rounded-lg form-input"
            id="box-form"
          >
            <button
              className="absolute right-3 h-6 w-6 cursor-pointer border rounded-full hover:bg-gray-100 transition"
              onClick={props.HandleClose}
            >
              <span>X</span>
            </button>
            <h2 className="text-2xl font-semibold  mb-4">
              CUPOM:{" "}
              <span className="text-[var(--color-primaria)]">
                {formatVoucher(props.voucher)}
              </span>
            </h2>
            {loading && <p>Carregando dados...</p>}
            <form onSubmit={handleSubmit(onSubmitForm)}>
              <div className="max-h-[75vh] overflow-y-auto pr-2">
                <div className="flex flex-col md:flex-row gap-6">
                  {/* CARD 1 */}
                  <div className="w-full p-2 rounded-xl shadow-sm bg-[var(--color-background)] text-start text-gray-900">
                    <h4 className="text-lg font-semibold uppercase mb-1">
                      Dados para Resgate do Cupom
                    </h4>
                    <div className="flex flex-col md:flex-row md:items-start gap-4">
                      {/* Documento */}
                      <div className="w-full">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          Documento <span className="text-red-500">*</span>
                        </label>
                        <input type="hidden" id="idcliente" />
                        <input
                          readOnly={true}
                          data-testid="input-documento"
                          type="text"
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          className="w-full border bg-gray-200 border-gray-400 
                          rounded-md 
                          px-4 py-1 
                          text-sm
                          placeholder-gray-400
                          focus:border-primary
                          focus:ring-2
                          focus:ring-primary/20
                          transition focus:outline-none "
                          onChange={handleDocumento}
                          value={formatDocumentType(
                            requestBody.vouch_binu_documento,
                            requestBody?.vouch_dmtp_documento === "F"
                              ? "F"
                              : "J",
                          )}
                          id="documento"
                          placeholder={`Digite o documento (${
                            requestBody?.vouch_dmtp_documento === "F"
                              ? "CPF"
                              : requestBody?.vouch_dmtp_documento === "J"
                                ? "CNPJ"
                                : "CPF/CNPJ"
                          })`}
                          autoComplete="off"
                        />
                        {errors.vouch_binu_documento?.message ? (
                          <span className="text-red-500 text-xs">
                            {errors.vouch_binu_documento?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>
                    </div>

                    {/* Nome / Razão Social */}
                    {onlyName ? (
                      <div className="flex flex-col md:flex-row md:items-start gap-4">
                        <div className="w-full">
                          <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                            Nome <span className="text-red-500">*</span>
                          </label>
                          <input
                            data-testid="input-nome"
                            type="text"
                            style={
                              {
                                "--tw-ring-color": "var(--color-primary)",
                                borderColor: undefined,
                              } as React.CSSProperties
                            }
                            readOnly={clientReadOnly}
                            value={
                              requestBody.vouch_vcnm_responsavel.toUpperCase() ||
                              ""
                            }
                            className="w-full border border-gray-400  
                              rounded-md 
                              px-4 py-1 
                              text-sm
                              placeholder-gray-400
                              focus:border-primary
                              focus:ring-primary/20
                              transition focus:outline-none focus:ring-2 "
                            maxLength={countField}
                            onChange={handleNomeResponsavel}
                            placeholder="Digite o nome"
                          />
                          {errors.vouch_vcnm_responsavel?.message ? (
                            <span className="text-red-500 text-xs">
                              {errors.vouch_vcnm_responsavel?.message}
                            </span>
                          ) : (
                            <span className="text-transparent text-xs">-</span>
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="flex flex-col md:flex-row md:items-start gap-4">
                          <div className="w-full">
                            <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                              Razão Social{" "}
                              <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              style={
                                {
                                  "--tw-ring-color": "var(--color-primary)",
                                  borderColor: undefined,
                                } as React.CSSProperties
                              }
                              readOnly={clientReadOnly}
                              value={
                                requestBody.vouch_vcnm_razaosocial.toUpperCase() ||
                                ""
                              }
                              className="w-full border border-gray-400 
                                rounded-md 
                                px-4 py-1 
                                text-sm
                                placeholder-gray-400
                                focus:border-primary
                                focus:ring-primary/20
                                transition focus:outline-none focus:ring-2 "
                              maxLength={countField}
                              onChange={handleNomeRazaoSocial}
                              placeholder="Digite a Razão Social"
                            />
                            {errors.vouch_vcnm_razaosocial?.message ? (
                              <span className="text-red-500 text-xs">
                                {errors.vouch_vcnm_razaosocial?.message}
                              </span>
                            ) : (
                              <span className="text-transparent text-xs">
                                -
                              </span>
                            )}
                          </div>
                        </div>
                        {!onlyName && (
                          <div className="flex flex-col md:flex-row md:items-start gap-4">
                            <div className="w-full">
                              <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                                Nome Fantasia{" "}
                                <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                style={
                                  {
                                    "--tw-ring-color": "var(--color-primary)",
                                    borderColor: undefined,
                                  } as React.CSSProperties
                                }
                                readOnly={clientReadOnly}
                                value={
                                  requestBody.vouch_vcnm_fantasia.toUpperCase() ||
                                  ""
                                }
                                className="w-full border border-gray-400 
                                rounded-md
                                px-4 py-1 
                                text-sm
                                placeholder-gray-400
                                focus:border-primary
                                focus:ring-primary/20
                                transition focus:outline-none focus:ring-2 "
                                id="nomeFantasia"
                                onChange={handleNomeFantasia}
                                maxLength={countField}
                                placeholder="Digite o nome fantasia"
                              />
                              {errors.vouch_vcnm_fantasia?.message ? (
                                <span className="text-red-500 text-xs">
                                  {errors.vouch_vcnm_fantasia?.message}
                                </span>
                              ) : (
                                <span className="text-transparent text-xs">
                                  -
                                </span>
                              )}
                            </div>
                          </div>
                        )}
                        <div className="flex flex-col md:flex-row md:items-start gap-4">
                          <div className="w-2/4">
                            <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                              Documento do Responsável
                              <span className="text-red-500">*</span>
                            </label>
                            <input type="hidden" id="idcliente" />
                            <input
                              readOnly={clientReadOnly}
                              data-testid="input-document-responsavel"
                              type="text"
                              style={
                                {
                                  "--tw-ring-color": "var(--color-primary)",
                                  borderColor: undefined,
                                } as React.CSSProperties
                              }
                              className="w-full border border-gray-400 
                          rounded-md 
                          px-4 py-1 
                          text-sm
                          placeholder-gray-400
                          focus:border-primary
                          focus:ring-2
                          focus:ring-primary/20
                          transition focus:outline-none "
                              onChange={handleDocumentoResponsavel}
                              value={formatDocumentType(
                                requestBody.vouch_dmnu_cpfresponsavel,
                                "F",
                              )}
                              id="documento"
                              maxLength={countDocumentResponsavel}
                              placeholder={`Digite o documento (${
                                requestBody?.vouch_dmnu_cpfresponsavel === "F"
                                  ? "CPF"
                                  : requestBody?.vouch_dmnu_cpfresponsavel ===
                                      "J"
                                    ? "CNPJ"
                                    : "CPF/CNPJ"
                              })`}
                              autoComplete="off"
                            />
                            {errors.vouch_dmnu_cpfresponsavel?.message ? (
                              <span className="text-red-500 text-xs">
                                {errors.vouch_dmnu_cpfresponsavel?.message}
                              </span>
                            ) : (
                              <span className="text-transparent text-xs">
                                -
                              </span>
                            )}
                          </div>

                          <div className="w-full">
                            <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                              Nome do Responsável{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              data-testid="input-nome-responsavel"
                              type="text"
                              style={
                                {
                                  "--tw-ring-color": "var(--color-primary)",
                                  borderColor: undefined,
                                } as React.CSSProperties
                              }
                              readOnly={clientReadOnly}
                              value={
                                requestBody.vouch_vcnm_responsavel.toUpperCase() ||
                                ""
                              }
                              className="w-full border border-gray-400  
                              rounded-md 
                              px-4 py-1 
                              text-sm
                              placeholder-gray-400
                              focus:border-primary
                              focus:ring-primary/20
                              transition focus:outline-none focus:ring-2 "
                              maxLength={countField}
                              onChange={handleNomeResponsavel}
                              placeholder="Digite o nome"
                            />
                            {errors.vouch_vcnm_responsavel?.message ? (
                              <span className="text-red-500 text-xs">
                                {errors.vouch_vcnm_responsavel?.message}
                              </span>
                            ) : (
                              <span className="text-transparent text-xs">
                                -
                              </span>
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {/* Telefones */}
                    <div className="flex flex-col md:flex-row md:items-start gap-4">
                      <div className="w-2/4">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          Celular do Responsável{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          data-testid="input-telefone-celular"
                          type="text"
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          readOnly={clientReadOnly}
                          value={formatPhone(
                            requestBody.vouch_binu_telefoneresponsavel,
                          )}
                          className="w-full border border-gray-400 
                            rounded-md 
                            px-4 py-1 
                            text-sm
                            placeholder-gray-400
                            focus:border-primary
                            focus:ring-primary/20
                            transition focus:outline-none focus:ring-2 "
                          id="tCelular"
                          onChange={handleTelefone}
                          onBlur={handleTelefone}
                          maxLength={countCelular}
                          placeholder="Digite o telefone celular (com DDD)"
                        />
                        {errors.vouch_bite_celular?.message ? (
                          <span className="text-red-500 text-xs">
                            {errors.vouch_bite_celular?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>
                      <div className="w-full">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          E-mail do Responsável
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          data-testid="input-email"
                          type="email"
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          readOnly={clientReadOnly}
                          value={
                            requestBody.vouch_vcem_responsavel.toLowerCase() ||
                            ""
                          }
                          className="w-full border border-gray-400 
                            rounded-md 
                            px-4 py-1 
                            text-sm
                            placeholder-gray-400
                            focus:border-primary
                            focus:ring-primary/20
                            transition focus:outline-none focus:ring-2 "
                          onChange={handleEmail}
                          maxLength={countField}
                          placeholder="Digite o e-mail"
                        />
                        {errors.vouch_vcem_responsavel?.message ? (
                          <span className="text-red-500 text-xs">
                            {errors.vouch_vcem_responsavel?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* CARD 2 — ENDEREÇO */}
                  <div className="w-full p-2 rounded-xl shadow-sm bg-[var(--color-background)] text-start text-gray-900">
                    <h4 className="text-lg font-semibold uppercase mb-1">
                      Endereço
                    </h4>

                    {/* CEP e Logradouro */}
                    <div className="flex flex-col md:flex-row md:items-start gap-4">
                      <div className="w-full">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          CEP <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          readOnly={clientReadOnly}
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          value={formatCEP(requestBody.vouch_chcd_cep)}
                          className="w-full border border-gray-400 
                            rounded-md 
                            px-4 py-1 
                            text-sm
                            placeholder-gray-400
                            focus:border-primary
                            focus:ring-primary/20
                            transition focus:outline-none focus:ring-2 "
                          id="cep"
                          // onChange={handleCEP}
                          onChange={(e) => {
                            handleCEP(e);
                            if (e.target.value.length >= 8) {
                              const rawValue = formatNumber(e.target.value);
                              searchCEP(rawValue);
                            }
                          }}
                          maxLength={countCep}
                          placeholder="Digite o CEP"
                        />
                        {errors.vouch_chcd_cep?.message ? (
                          <span className="text-red-500 text-xs">
                            {errors.vouch_chcd_cep?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>
                    </div>

                    {/* Endereço e Número */}
                    <div className="flex flex-col md:flex-row md:items-start gap-4">
                      <div className="w-full">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          Endereço <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          readOnly={clientReadOnly}
                          value={
                            requestBody.vouch_vcds_endereco.toUpperCase() || ""
                          }
                          className="w-full border border-gray-400 
                            rounded-md 
                            px-4 py-1 
                            text-sm
                            placeholder-gray-400
                            focus:border-primary
                            focus:ring-primary/20
                            transition focus:outline-none focus:ring-2 "
                          onChange={handleEndereco}
                          maxLength={countField}
                          placeholder="Digite o endereço"
                        />
                        {errors.vouch_vcds_endereco?.message ? (
                          <span className="text-red-500 text-xs">
                            {errors.vouch_vcds_endereco?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>
                    </div>

                    {/* Complemento */}
                    <div className="flex flex-col md:flex-row md:items-start gap-4">
                      <div className="w-1/4">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          Número <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          readOnly={clientReadOnly}
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          value={requestBody.vouch_vcnu_numero}
                          className="w-full border border-gray-400 
                            rounded-md 
                            px-4 py-1 
                            text-sm
                            placeholder-gray-400
                            focus:border-primary
                            focus:ring-primary/20
                            transition focus:outline-none focus:ring-2 "
                          onChange={handleNumero}
                          maxLength={countNumero}
                          placeholder="Digite o número"
                        />
                        {errors.vouch_vcnu_numero?.message ? (
                          <span className="text-red-500 text-xs scroll">
                            {errors.vouch_vcnu_numero?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>
                      <div className="w-full">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          Complemento
                        </label>
                        <input
                          type="text"
                          readOnly={clientReadOnly}
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          value={
                            requestBody.vouch_vcds_complemento
                              ? requestBody.vouch_vcds_complemento.toLocaleUpperCase()
                              : ""
                          }
                          className="w-full border border-gray-400 
                          rounded-md 
                          px-4 py-1 
                          text-sm
                          placeholder-gray-400
                          focus:border-primary
                          focus:ring-primary/20
                          transition focus:outline-none focus:ring-2 "
                          onChange={handleComplemento}
                          maxLength={countField}
                          placeholder="Digite o complemento"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col md:flex-row md:items-start gap-4">
                      <div className="w-full">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          Bairro <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          readOnly={clientReadOnly}
                          value={
                            requestBody.vouch_vcnm_bairro.toLocaleUpperCase() ||
                            ""
                          }
                          className="w-full border border-gray-400 
                            rounded-md 
                            px-4 py-1 
                            text-sm
                            placeholder-gray-400
                            focus:border-primary
                            focus:ring-primary/20
                            transition focus:outline-none focus:ring-2 "
                          onChange={handleBairro}
                          maxLength={countField}
                          placeholder="Digite o bairro"
                        />
                        {errors.vouch_vcnm_bairro?.message ? (
                          <span className="text-red-500 text-xs">
                            {errors.vouch_vcnm_bairro?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>
                    </div>

                    {/* Bairro e Cidade */}

                    <div className="flex flex-col md:flex-row md:items-start gap-4">
                      <div className="w-full">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          Cidade <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          readOnly={clientReadOnly}
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          value={
                            requestBody.vouch_vcnm_cidade.toLocaleUpperCase() ||
                            ""
                          }
                          className="w-full border border-gray-400 
                            rounded-md 
                            px-4 py-1 
                            text-sm
                            placeholder-gray-400
                            focus:border-primary
                            focus:ring-primary/20
                            transition focus:outline-none focus:ring-2 "
                          onChange={handleCidade}
                          maxLength={countField}
                          placeholder="Digite a cidade"
                        />
                        {errors.vouch_vcnm_cidade?.message ? (
                          <span className="text-red-500 text-xs">
                            {errors.vouch_vcnm_cidade?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>

                      {/* UF */}
                      <div className="w-2/4">
                        <label className="block text-xs font-medium var(--color-texto-menu) mb-1 uppercase tracking-wide ml-2">
                          UF <span className="text-red-500">*</span>
                        </label>
                        <select
                          style={
                            {
                              "--tw-ring-color": "var(--color-primary)",
                              borderColor: undefined,
                            } as React.CSSProperties
                          }
                          className="w-full border border-gray-400 
                            rounded-md 
                            px-4 py-1 
                            text-sm
                            placeholder-gray-400
                            focus:border-primary
                            focus:ring-primary/20
                            transition focus:outline-none focus:ring-2 "
                          value={requestBody.vouch_chcd_uf}
                          id="UF"
                          onChange={handleEstado}
                          disabled={clientReadOnly}
                        >
                          <option defaultValue="0">Selecione o Estado</option>
                          {uf.map(({ sigla, nome }) => (
                            <option key={sigla} value={sigla}>
                              {nome.toUpperCase() || ""}
                            </option>
                          ))}
                        </select>
                        {errors.vouch_chcd_uf?.message ? (
                          <span className="text-red-500 text-xs">
                            {errors.vouch_chcd_uf?.message}
                          </span>
                        ) : (
                          <span className="text-transparent text-xs">-</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <span className="text-red-500 font-semibold text-sm">
                  O CELULAR e o E-MAIL do RESPONSÁVEL serão usados para envio
                  dos eventos do serviço habilitado.
                </span>
              </div>
              <div className="flex flex-row justify-center pt-4">
                <Button
                  type="submit"
                  name="Enviar"
                  className="
                    px-24 py-4
                    rounded-md
                    text-base
                    font-bold
                    shadow-lg
                    hover:scale-[1.02]
                    active:scale-[0.98]
                    transition-transform duration-[400ms] ease-out
                  "
                  color={"var(--color-secundaria)"}
                  fontColor={"var(--color-primaria)"}
                  borderColor={"var(--color-primaria)"}
                  boxShadow={"0 10px 25px rgba(0,0,0,0.15)"}
                  transform={"translateY(-1px)"}
                />
              </div>
            </form>
          </div>
          {loading && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-10">
              <div className="spinner-border text-secondary" role="status">
                <span className="sr-only"></span>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {progressBar > 100 ? (
            <>
              <div className="relative w-[90%] min-w-[300px] bg-white border border-white/80 my-5 mx-auto mt-[9%] p-20 overflow-visible rounded-lg">
                {errorProgress ? (
                  <>
                    <button
                      className="absolute right-4 top-4 h-6 w-6 cursor-pointer border rounded-full hover:bg-gray-100 transition"
                      onClick={props.HandleClose}
                    >
                      <span>X</span>
                    </button>
                    <h2 className="text-3xl mb-5 font-semibold text-red-600">
                      {errorTextProgress} <Dangerous className="text-red-600" />
                    </h2>
                    <div className="flex-1 text-lg mb-2">
                      <p>
                        Entre em contato com o suporte{" "}
                        <a
                          className="text-blue-500 underline"
                          href={`http://wa.me/556130383530?text=Tive%20problemas%20com%20meu%20voucher%20${props.voucher}`}
                        >
                          clicando aqui{" "}
                        </a>
                        ou{" "}
                        <a
                          href={window.location.href}
                          className="text-blue-500 underline"
                        >
                          recarregue
                        </a>{" "}
                        a página para tentar novamente.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <h3 className="text-6xl text-[var(--color-primaria)] font-bold">
                      PARABÉNS!
                    </h3>
                    <div className="flex-1 text-2xl mb-2">
                      <p>Seu CUPOM foi resgatado com sucesso.</p>
                      <br />
                      <br />
                      <br />
                      <p className="">
                        Você será redirecionado automaticamente em até{" "}
                        {countRedirect} segundos. <br />
                        Caso isso não aconteça,{" "}
                        <a
                          href={linkRedirect}
                          className="text-blue-500 underline"
                        >
                          clique aqui
                        </a>
                        !
                      </p>
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              <div
                className="relative w-[90%] min-w-[300px] bg-white border border-white/80 my-5 mx-auto p-5 overflow-visible rounded-lg form-input"
                id="box-form"
              >
                <div className="bar-progress">
                  <div className="flex flex-col mb-3">
                    <div className="flex-1">
                      <h2 className="text-3xl mb-5 font-semibold">
                        {titleProgressBar}
                      </h2>
                    </div>
                    <div className="flex-1 text-lg mb-2">
                      {typeof textProgressBar === "string" &&
                        textProgressBar.includes("<") && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: textProgressBar,
                            }}
                          />
                        )}
                    </div>
                    <div className="flex-1 w-full mt-4">
                      <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-300 border-t-[var(--color-primaria)]" />
                      </div>
                    </div>

                    <div className="flex-1 w-full place-items-center hidden md:block mt-4">
                      <div className="relative w-3/4 h-full bg-gray-200 rounded-lg overflow-hidden">
                        <img
                          src={images[carouselIndex]}
                          alt="Carrossel"
                          className="w-full h-[80%] object-cover transition-opacity duration-500"
                        />

                        <button
                          onClick={handlePrev}
                          className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition"
                        >
                          ❮
                        </button>
                        <button
                          onClick={handleNext}
                          className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition"
                        >
                          ❯
                        </button>

                        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-2">
                          {images.map((_, index) => (
                            <button
                              key={index}
                              onClick={() => setCarouselIndex(index)}
                              className={`w-2 h-2 rounded-full transition ${
                                index === carouselIndex
                                  ? "bg-white"
                                  : "bg-white/50"
                              }`}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                    {errorProgress ? (
                      <p>
                        <span style={{ color: "red" }}>
                          {errorTextProgress}
                        </span>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
function mapStateToProps(state: any) {
  return {
    whitelabel: state.whiteLabel,
    session: state.session,
  };
}
export default connect(mapStateToProps)(FormToBuy);
